var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data && _vm.q
    ? _c("div", [
        _c(
          "nav",
          { staticClass: "navbar fixed-top" },
          [
            _c(
              "router-link",
              {
                class: _vm.disableHref ? "disabled-href" : "",
                attrs: { to: "/" }
              },
              [
                _c("img", {
                  staticClass: "img-logo img-fluid",
                  attrs: {
                    src: require("@/assets/img/checkme_logo.svg?data"),
                    alt: "CheckMe logo"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _vm.env === "dev" || _vm.env === "qa"
              ? _c(
                  "button",
                  {
                    staticClass: "text-center cursor-pointer env--small",
                    on: {
                      click: function($event) {
                        return _vm.clearStorage()
                      }
                    }
                  },
                  [_vm._v("\n      clear storage\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.env === "dev" || _vm.env === "qa"
              ? _c("small", { staticClass: "text-center env--small" }, [
                  _vm._v("Miljö: " + _vm._s(_vm.env))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                { staticClass: "radio-buttons-container" },
                _vm._l(_vm.q.top.languageList, function(code, lang) {
                  return _c(
                    "div",
                    { key: code, staticClass: "radio-button-item" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.language,
                            expression: "language"
                          }
                        ],
                        attrs: { type: "radio", id: "language_" + code },
                        domProps: {
                          value: code,
                          checked: _vm._q(_vm.language, code)
                        },
                        on: {
                          change: function($event) {
                            _vm.language = code
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "language-label",
                          staticStyle: { "font-size": "small" },
                          attrs: { for: "language_" + code }
                        },
                        [_vm._v(_vm._s(lang))]
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "navbar-toggler img-fluid",
              attrs: {
                src: require("@/assets/img/hamburger.svg?data"),
                alt: "Ikon för hamburgarmeny",
                "data-toggle": "collapse",
                "data-target": "#collapsibleNavbar"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse navbar-collapse",
                attrs: { id: "collapsibleNavbar" }
              },
              [
                _c("hr"),
                _vm._v(" "),
                _c("ul", { staticClass: "navbar-nav" }, [
                  _c("li", { staticClass: "nav-item" }, [
                    _c("a", {
                      staticClass: "nav-link text-primary",
                      class: _vm.disableHref ? "disabled-href" : "",
                      attrs: { href: "/" },
                      domProps: {
                        innerHTML: _vm._s(_vm.data.faq.topHeaderStart)
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c("router-link", {
                        staticClass: "nav-link text-primary",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#collapsibleNavbar",
                          to: {
                            name: "faq",
                            params: { page: _vm.pages.aboutapp }
                          }
                        },
                        domProps: {
                          innerHTML: _vm._s(_vm.data.faq.topHeaderAbout)
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c("router-link", {
                        staticClass: "nav-link text-primary",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#collapsibleNavbar",
                          to: {
                            name: "faq",
                            params: { page: _vm.pages.cookies }
                          }
                        },
                        domProps: {
                          innerHTML: _vm._s(_vm.data.faq.cookiesHeader)
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c("router-link", {
                        staticClass: "nav-link text-primary",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": "#collapsibleNavbar",
                          to: {
                            name: "faq",
                            params: { page: _vm.pages.contact }
                          }
                        },
                        domProps: {
                          innerHTML: _vm._s(_vm.data.faq.topHeaderContact)
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.notRootOrLogin() && _vm.doesTokenExist()
                    ? _c("div", { staticClass: "dropdown-divider" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.notRootOrLogin() && _vm.doesTokenExist()
                    ? _c("li", { staticClass: "nav-item" }, [
                        _c(
                          "span",
                          {
                            staticClass: "nav-link text-primary cursor-pointer",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": "#collapsibleNavbar"
                            },
                            on: {
                              click: function($event) {
                                return _vm.logOut()
                              }
                            }
                          },
                          [_c("strong", [_vm._v("Logga ut")])]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ab79656", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab79656","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
// module id = null
// module chunks = 